exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".text__FinFacturerenModal-module___2-Vg6 {\n    border: 1px solid #ffeff2;\n    background-color: #ffeff2;\n    border-radius: 0.375rem;\n    padding: 5px 10px;\n    margin: 12px 0;\n}", ""]);

// Exports
exports.locals = {
	"text": "text__FinFacturerenModal-module___2-Vg6"
};